// extracted by mini-css-extract-plugin
export var alternate = "_11-h";
export var black = "_11-3";
export var blue = "_11-d";
export var blueLight = "_11-c";
export var brand = "_11-7";
export var error = "_11-9";
export var gray = "_11-6";
export var grayBlue = "_11-b";
export var iconWrapper = "_11-4";
export var indigo = "_11-e";
export var orange = "_11-g";
export var pink = "_11-f";
export var primary = "_11-0";
export var purple = "_11-8";
export var success = "_11-5";
export var warning = "_11-a";
export var white = "_11-1";
export var whiteSuccess = "_11-2";